import React from 'react';
import PropTypes from 'prop-types';
import { getColor } from '../helpers';
import Money from '../../../common/money';
import Num from '../../../common/Num';

const PieChartLegend = ({ data, automationId }) => (
  <div>
    <div className="o-tableize o-tableize--middle u-co-darkgray u-text-left">
      {data.map((item, index) => (
        <div className="o-tableize__row" key={item.id}>
          <div className="o-tableize__cell u-pb">
            <div className="c-led c-led--large u-mr-" style={{ backgroundColor: getColor(index) }} />
          </div>

          <div
            className="o-tableize__cell o-tableize__cell--fill u-pb"
            data-automation-id={`text:${automationId}:Name:${index}`}
          >
            {item.name}
          </div>

          <div className="o-tableize__cell u-text-right u-pb">
            <Money
              display-if={!item.empty && item.type !== 'number'}
              automationId={`text:${automationId}:Value:${index}`}
            >
              {item.value}
            </Money>
            <Num
              display-if={!item.empty && item.type === 'number'}
              automationId={`text:${automationId}:Value:${index}`}
            >
              {item.value}
            </Num>
          </div>
        </div>
      ))}
    </div>
  </div>
);

PieChartLegend.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  automationId: PropTypes.string,
};

PieChartLegend.defaultProps = {
  data: {},
  automationId: null,
};

export default PieChartLegend;
